
import Vue from "vue";
import { Component } from "vue-property-decorator";
import IframeCanvas from "@/components/Canvas/IframeCanvas.vue";
import { uiStore, singularityStore } from "@/store/store";
import { PHONE_PORTRAIT_BREAKPOINT_ID } from "@/components/Singularity/TopNav/TopNavToggleMobile.vue";

@Component({
  components: {
    IframeCanvas
  }
})
export default class SingularityCanvas extends Vue {
  get isMobile() {
    return uiStore.currentBreakpoint.id === PHONE_PORTRAIT_BREAKPOINT_ID;
  }

  get isZoomedOut() {
    return !this.isMobile && singularityStore.canvasZoom;
  }
}
